import _ from "underscore";

import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from "prop-types";

import BaseMixin from './BaseMixin';
import NumberCompareTerminalMixin from './NumberCompareTerminalMixin';
import Styles from './../StyleSheet';

const MoneyCompareTerminal = createReactClass({
  displayName: 'MoneyCompareTerminal',
  mixins: [BaseMixin, NumberCompareTerminalMixin],

  propTypes: {
    node: PropTypes.object.isRequired,
    editable: PropTypes.bool
  },

  render: function() {
    return (
      <form className="form-inline">
        {this.renderTerminalName()}
        {this.renderRelOp()}
        {this.renderMoneyValue()}
      </form>
    );
  },

  renderMoneyValue: function() {
    return (
      <input
        className="form-control"
        style={this._moneyValueStyles()}
        value={this.props.node.get('value')}
        onChange={this._onValueChange}
        disabled={!this.props.editable} />
    );
  },

  _moneyValueStyles: function() {
    return (
      _.extend(
        {},
        { width: this.props.editable ? '100px' : 'auto' },
        Styles.lastChild
      )
    );
  }
});

export default MoneyCompareTerminal;
